import { createContext, useContext } from "react";
import type { ManagedUser } from "./types";
import type { Trial } from "./trials-api";

export type TrialActions = {
  onStartTrial: (user: ManagedUser) => void;
  onManageTrial: (user: ManagedUser, trial: Trial) => void;
  onReactivateTrial: (user: ManagedUser) => void;
};

const TrialActionsContext = createContext<TrialActions | null>(null);

export const TrialActionsProvider = TrialActionsContext.Provider;

export const useTrialActions = () => useContext(TrialActionsContext);
